import messages from './messages';

const schema = ({ intl }) => ({
  title: intl.formatMessage(messages.blockTitle),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.defaultFieldset),
      fields: [
        'eyebrow',
        'title',
        'count_label',
        'header_image',
        'show_allergen_notice',
        'items',
      ],
    },
  ],
  properties: {
    eyebrow: { title: intl.formatMessage(messages.eyebrow), type: 'string' },
    title: { title: intl.formatMessage(messages.title), type: 'string' },
    count_label: {
      title: intl.formatMessage(messages.countLabel),
      type: 'string',
    },
    header_image: {
      title: intl.formatMessage(messages.headerImage),
      type: 'string',
      widget: 'object_browser',
      mode: 'image',
      description: intl.formatMessage(messages.headerImageDescription),
    },
    show_allergen_notice: {
      title: intl.formatMessage(messages.showAllergenNotice),
      type: 'boolean',
      default: false,
    },
    items: {
      title: intl.formatMessage(messages.items),
      type: 'array',
      widget: 'object_list',
      schema: {
        title: intl.formatMessage(messages.itemTitle),
        addMessage: intl.formatMessage(messages.addItem),
        fieldsets: [
          {
            id: 'default',
            title: intl.formatMessage(messages.itemTitle),
            fields: [
              'title',
              'description',
              'allergens',
              'price',
              'price_supplement',
              'price_accent',
              'full_width',
              'image',
            ],
          },
        ],
        properties: {
          title: { title: intl.formatMessage(messages.name), type: 'string' },
          description: {
            title: intl.formatMessage(messages.description),
            type: 'string',
            widget: 'textarea',
          },
          allergens: {
            title: intl.formatMessage(messages.allergens),
            type: 'array',
            items: { type: 'string' },
            description: intl.formatMessage(messages.allergensDescription),
          },
          price: { title: intl.formatMessage(messages.price), type: 'string' },
          price_supplement: {
            title: intl.formatMessage(messages.priceSupplement),
            type: 'string',
          },
          price_accent: {
            title: intl.formatMessage(messages.priceAccent),
            type: 'boolean',
          },
          full_width: {
            title: intl.formatMessage(messages.fullWidth),
            type: 'boolean',
          },
          image: {
            title: intl.formatMessage(messages.itemImage),
            type: 'string',
            widget: 'object_browser',
            mode: 'image',
          },
        },
      },
    },
  },
  required: [],
});

export default schema;
